import React from 'react';
import { OnboardingWizard } from '../components/forms/OnboardingWizard';
interface OnboardingProps {
  navigate: (page: string, context?: any) => void;
}
export function Onboarding({
  navigate
}: OnboardingProps) {
  return <OnboardingWizard navigate={navigate} data-id="element-3718" />;
}